module.exports = __webpack_public_path__ + "static/media/happy caskshare collective member.9b0b840b.jpg";